<h1 mat-dialog-title>Set custom monthly allowance</h1>
<div mat-dialog-content class="form-wrapper">
  <span class="teammembername">{{ member.email }}</span>
  <form class="form" *ngIf="form" [formGroup]="form" padding>
    <mat-form-field>
      <mat-label>Monthly Allowance ($)</mat-label>
      <input
        matInput
        #allowance
        type="text"
        formControlName="allowance"
        (keypress)="validateNumber($event)"
        (paste)="validatePaste($event)"
        (blur)="formatCurrency()"
        [placeholder]="(member.monthlyAllowance || amount || 0 | currency) || ''"
      />
    </mat-form-field>
  </form>
</div>
<div class="buttons" mat-dialog-actions>
  <button
    mat-raised-button
    [disabled]="!form.valid"
    class="donebutton"
    color="primary"
    (click)="setCustomMonthlyAllowance()"
  >
    Save
  </button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
